export default "__VITE_ASSET__DJwIIH56__"